import { render, staticRenderFns } from "./creatEdit.vue?vue&type=template&id=7b2cc8b4"
import script from "./creatEdit.vue?vue&type=script&lang=js"
export * from "./creatEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports